import { Globe } from 'lucide-react';
import { getTimezoneAbbr, isIST } from '../lib/utils';

export default function TimezoneHeader() {
  const tz = getTimezoneAbbr();
  const isIndian = isIST();

  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground bg-muted/40 rounded-lg px-2.5 py-1 w-fit">
      <Globe className="h-3 w-3" />
      <span>Times shown in <strong>{tz}</strong>{!isIndian && ' (converted from IST)'}</span>
    </div>
  );
}
